import { client } from '@/shared/apollo-api/business/client';
import type { GetSuggestionsInput, GetSuggestionsResult } from '@/shared/apollo-api/__generated__/types';
import { gql } from '@apollo/client/core';
  
export const getSuggestions = async (
  suggestionsQuery: GetSuggestionsInput,
): Promise<GetSuggestionsResult> => {
  const {
    data: { getSuggestions },
  } = await client.query({
    query: gql`
      query Suggestions($GetSuggestionsInput: GetSuggestionsInput!) {
        getSuggestions(query: $GetSuggestionsInput) {
          blocks {
            ... on TextSuggestionsBlock {
              values
            }
            ... on PopularSuggestionsBlock {
              popularSuggestions
            }
            ... on CatalogCardSuggestionsBlock {
              cards {
                ... on ProductCard {
                  title
                  minFullPrice
                  minSellPrice
                  productId
                  photos {
                    original {
                      low
                    }
                  }
                }
              }
            }
            ... on CategorySuggestionsBlock {
              categories {
                title
                id
                icon
                parent {
                  id
                  title
                }
                seo {
                  metaTag
                }
              }
            }
            ... on ShopSuggestionsBlock {
              shops {
                id
                title
                url
                avatar {
                  low
                }
              }
            }
          }
        }
      }
    `,
    variables: {
      GetSuggestionsInput: suggestionsQuery,
    },
    errorPolicy: 'all',
  });

  return getSuggestions;
};
